import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-3 mt-5">
      <p>© 2025 GenAI Finance. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
